import { html } from "lit-html";
import { useAjax } from "Services/useAjax";
import { ActionType } from "./DynamicSettings";
import { submitActionOnlyPost } from "./adminCommon";

export interface Props {
	isPreview: boolean;
}

export const useGlobalButtonsSection = (props: Props) => {
	const { ajaxRequest } = useAjax();

	const submit = async (e: MouseEvent, actionName: ActionType) => {
		e.preventDefault();
		e.stopPropagation();
		await submitActionOnlyPost(actionName, ajaxRequest);
	};

	const htmlTemplate = () => html`
		<section
			class="fixed bottom-0 left-64 right-0 flex h-11 items-center justify-end gap-x-10 border-t border-solid border-n-dark-gray bg-n-blue bg-opacity-10 px-10"
		>
			<button
				class="small bg-n-blue hover:bg-n-red hover:text-white"
				@click=${(e: MouseEvent) => submit(e, "take_home_snapshot")}
			>
				Take Home Snapshot
			</button>
			${props.isPreview
				? html`
						<button
							class="small bg-[#59c3d9] hover:bg-n-blue hover:text-white"
							@click=${(e: MouseEvent) => submit(e, "preview_off")}
						>
							Switch OFF Preview
						</button>
				  `
				: html`<button
						type="submit"
						class="small bg-n-red hover:bg-n-blue hover:text-white"
						@click=${(e: MouseEvent) => submit(e, "preview_on")}
				  >
						Switch ON Preview
				  </button>`}

			<button
				class="small bg-n-red hover:bg-n-blue hover:text-white"
				value="Logoff"
				@click=${(e: MouseEvent) => submit(e, "logoff")}
			>
				Log out
			</button>
		</section>
	`;

	return { htmlTemplate };
};
